import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function walletAddressHeader(theme: Theme): ComponentStyle {
  return {
    componentName: 'walletAddressHeader',
    sizes: {
      '2': {
        fontSize: theme.sizes[2]
      }
    }
  };
}
